"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Icon, { CheckIcon, MinusIcon } from "../../icons/index.js";
import SwitchBase from "../switch-base/switch-base.js";
function CheckboxIcon(_a) {
    var { checked, indeterminate } = _a, props = __rest(_a, ["checked", "indeterminate"]);
    return React.createElement(indeterminate ? MinusIcon : checked ? CheckIcon : Icon, Object.assign({ strokeWidth: 4 }, props));
}
export const Checkbox = React.forwardRef(function Checkbox(_a, ref) {
    var { value } = _a, props = __rest(_a, ["value"]);
    return _jsx(SwitchBase, Object.assign({ ref: ref, checked: value, "data-component": "checkbox", icon: CheckboxIcon, type: "checkbox" }, props));
});
export default Checkbox;
//# sourceMappingURL=checkbox.js.map